module.exports = "/assets/45e5a2af16125fe39b20e9113f3695e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/XC.png
// module id = 3109
// module chunks = 0